import React, { Component } from "react";
import { connect } from "react-redux";
import ProfileView from "./ProfileView";
import { setTokenAction } from "../../store/Layout/actions";
import { setTranslationsAction } from "../../store/Layout/actions";

class ProfileController extends Component {
  render() {
    return (
      <ProfileView
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        config={this.props.config}
        setTranslationsAction={this.props.setTranslationsAction}
        setTokenAction={this.props.setTokenAction}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    csrf_token: state.layout.csrf_token,
    config: state.layout.config,
    trans: state.layout.trans,
  };
};

const mapDispatchToProps = {
  setTokenAction,
  setTranslationsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileController);
